export const RESET = 'EXCMCASE_UPDATE_RESET'
export const SET_ERROR = 'EXCMCASE_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMCASE_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMCASE_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMCASE_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMCASE_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMCASE_UPDATE_UPDATE_RETRIEVED'
